import React from "react";

const TableIcon = ({ width = 16, height = 16 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    class=""
  >
    <path
      d="M15.4286 1.71094H0.571429C0.255357 1.71094 0 1.96629 0 2.28237V13.7109C0 14.027 0.255357 14.2824 0.571429 14.2824H15.4286C15.7446 14.2824 16 14.027 16 13.7109V2.28237C16 1.96629 15.7446 1.71094 15.4286 1.71094ZM14.7143 5.42522H10.9286V2.99665H14.7143V5.42522ZM14.7143 9.42522H10.9286V6.56808H14.7143V9.42522ZM6.21429 6.56808H9.78572V9.42522H6.21429V6.56808ZM9.78572 5.42522H6.21429V2.99665H9.78572V5.42522ZM1.28571 6.56808H5.07143V9.42522H1.28571V6.56808ZM1.28571 2.99665H5.07143V5.42522H1.28571V2.99665ZM1.28571 10.5681H5.07143V12.9967H1.28571V10.5681ZM6.21429 10.5681H9.78572V12.9967H6.21429V10.5681ZM14.7143 12.9967H10.9286V10.5681H14.7143V12.9967Z"
      fill="#485365"
    />
  </svg>
);
export default TableIcon;
